import { render } from "./PackageNotary.vue?vue&type=template&id=7d12bd59&scoped=true"
import script from "./PackageNotary.vue?vue&type=script&lang=js"
export * from "./PackageNotary.vue?vue&type=script&lang=js"

import "./PackageNotary.vue?vue&type=style&index=0&id=7d12bd59&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d12bd59"]])

export default __exports__